import ApiService from "@/common/api.service";

export const MapService = {
    async getCpdProvidersMap() {
        const res = await ApiService.get("/dashboard/maps/cpdProviders");
        return res.data;
    },
    async getAccrediatorsMap() {
        const res = await ApiService.get("/dashboard/maps/accrediators");
        return res.data;
    },
    async getMapByRegion(regionId, type) {
        const res = await ApiService.get(
            `/dashboard/maps/byLocation/${regionId}/${type}`
        );
        return res.data;
    },
    async getRegions() {
        const res = await ApiService.get("/location");
        return res.data ? res.data : [];
    },
};
